var exports = {
  "qb": "xe533113f--5bceb3--skeleton-item",
  "nV": "xe533113f--5bceb3--gallery",
  "AD": "xe533113f--5bceb3--gallery--wide",
  "jW": "xe533113f--5bceb3--photo",
  "_4": "xe533113f--5bceb3--thumbnails",
  "Qs": "xe533113f--5bceb3--content",
  "DD": "xe533113f--5bceb3--title",
  "VA": "xe533113f--5bceb3--subtitle",
  "Pf": "xe533113f--5bceb3--label",
  "QY": "xe533113f--5bceb3--geo",
  "q9": "xe533113f--5bceb3--price",
  "pW": "xe533113f--5bceb3--price-info",
  "h_": "xe533113f--5bceb3--description",
  "t$": "xe533113f--5bceb3--publisher",
  "my": "xe533113f--5bceb3--avatar",
  "$H": "xe533113f--5bceb3--agent-type",
  "UU": "xe533113f--5bceb3--name",
  "ay": "xe533113f--5bceb3--more-offers",
  "cq": "xe533113f--5bceb3--phone-button",
  "SB": "xe533113f--5bceb3--chat-button",
};

module.exports = exports;
